import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix, useIsRTL } from './ThemeProvider';
import { getOverlayDirection } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultProps = {
  placement: 'right'
};
var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    placement = _ref.placement,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    arrowProps = _ref.arrowProps,
    _ = _ref.popper,
    _2 = _ref.show,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "popper", "show"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'tooltip');
  var isRTL = useIsRTL();
  var _ref2 = (placement == null ? void 0 : placement.split('-')) || [],
    _ref3 = _slicedToArray(_ref2, 1),
    primaryPlacement = _ref3[0];
  var bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  return /*#__PURE__*/_jsxs("div", _objectSpread({
    ref: ref,
    style: style,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classNames(className, bsPrefix, "bs-tooltip-".concat(bsDirection))
  }, props, {
    children: [/*#__PURE__*/_jsx("div", _objectSpread({
      className: "tooltip-arrow"
    }, arrowProps)), /*#__PURE__*/_jsx("div", {
      className: "".concat(bsPrefix, "-inner"),
      children: children
    })]
  }));
});
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';
export default Tooltip;